import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import * as tios from './tios';
import * as simulator from './simulator';

export default class LCDGraphNode extends BaseNode {
    constructor() {
        super();
        this.name = 'LCD Graph';
        this.icon = 'BsGraphUp';
        this.id = 'node_lcd_graph';
        this.linkedFeature = 'lcd_graph';

        this.inputs = [
            {
                name: 'Add Point',
                portId: 'lcd_graph_add',
                params: [
                    {
                        name: 'point',
                        dataType: TibboDataType.INTEGER,
                        default: '0',
                    },
                ],
            },
        ];
    }

    getCodeBlocks(): CodeBlock[] {
        if (this.project.runtime === 'simulator') {
            return simulator.getCodeBlocks(this);
        }
        return tios.getCodeBlocks(this);
    }
}
